/**
 * Purpose:
 * Reusable Syncfusion dialog for action-level API errors.
 * Keeps business wording outside the component so feature screens can reuse one UI pattern.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'cwr-action-error-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './action-error-dialog.component.html',
    styleUrls: ['./action-error-dialog.component.scss'],
})
export class ActionErrorDialogComponent {
    @Input() visible = false;
    @Input() title = 'Action Failed';
    @Input() summary = 'The request could not be completed.';
    @Input() message = '';
    @Input() details: string[] = [];
    @Input() buttonText = 'OK';

    @Output() closed = new EventEmitter<void>();

    get buttons() {
        return [
            {
                click: () => this.closed.emit(),
                buttonModel: { content: this.buttonText, isPrimary: true },
            },
        ];
    }
}
